import {Component} from 'preact';
import cx from 'classnames';
import {mapRootUrl} from '@util/URLUtils';
import DropMenu from './DropMenu';
import {dropMenu} from './styles';
import NavItem from './NavItem';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import {NavigationContext} from '@modules/ui/header/DesktopMenu';
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';

const AllProductsMenu = ( {title, secondaryTitle, url, sysId, children, isFormulary} ) =>
    <NavItem title={title} url={url}>
        <DropMenu menuId={sysId}
                  className={cx( dropMenu.primaryMenu, {'nav-drop-menu--formulary': isFormulary} )}>
            <DropMenu.nav menuItems={children.map( mapRootUrl( {url: url} ) )}/>
        </DropMenu>
    </NavItem>;

class PrimaryNav extends Component {
    componentDidMount () {
        this.menuItems = this.navEl.querySelectorAll( '#nav-lvl-primary > ul > li' );

        new ResizeSensor( this.navEl.parentNode, () => this.toggleVisibleMenuItems() );
        this.toggleVisibleMenuItems();
    }

    toggleVisibleMenuItems () {
        let aggWidth = 0;
        const baseWidth = this.navEl.offsetWidth;

        [...this.menuItems].forEach( node => {
            node.style.display = 'block';
            aggWidth += node.getBoundingClientRect().width;
            node.style.display = (aggWidth < baseWidth) ? 'block' : 'none';
        } );
    }

    render () {
        const {taxonomy} = this.props;
        let allItemsMenu = null;
        let primaryNavList = taxonomy;
        let NavComponent = DropMenu.nav;

        return (
            <NavigationContext.Consumer>
                {( context ) => {
                    // if "Shopping: tab selected then root taxonomy to the "Products" tier of this taxonomy level
                    if ( context.isShoppingTaxonomy ) {
                        // will be either "formulary" or "all products"
                        allItemsMenu = mapRootUrl( taxonomy )( taxonomy.children[0] );
                        primaryNavList = context.hasFormulary
                            ? mapRootUrl( taxonomy )( taxonomy.children[1] )
                            : Object.assign( {}, allItemsMenu );

                        NavComponent = DropMenu.megaMenu;
                    }

                    return (
                        <ul ref={ref => this.navEl = ref}
                            className="absolute pin-l pin-r m-0 list-reset flex flex-0 justify-start">

                            {allItemsMenu &&
                                <AllProductsMenu {...allItemsMenu} isFormulary={context.hasFormulary}/>
                            }

                            {primaryNavList.children
                                .map( mapRootUrl( primaryNavList ) )
                                .map( ( {title, cssClass, navigationImage, url, children} ) => {
                                        // note -> use backgroundImage if source provided, else will fallback image declared in navigation.css
                                        const menuStyle = navigationImage?.source ?
                                            {backgroundImage: `url(${navigationImage.source})`} :
                                            null;
                                        if ( !isEmptyOrNil( children ) ) {
                                            return (
                                                <NavItem title={title} url={url}>
                                                    <DropMenu
                                                        style={menuStyle}
                                                        className={cx( cssClass, {
                                                            [dropMenu.megaMenu]: context.isShoppingTaxonomy,
                                                            [dropMenu.primaryMenu]: !context.isShoppingTaxonomy
                                                        } )}>
                                                        <NavComponent menuItems={children.map( mapRootUrl( {url} ) )}/>
                                                    </DropMenu>
                                                </NavItem>
                                            )
                                        }
                                        else {
                                            return <NavItem title={title} url={url}/>
                                        }
                                    }
                                )}
                        </ul>
                    );
                }}
            </NavigationContext.Consumer>
        );
    }
}

export default PrimaryNav;
